// src/sections/Projects.js
import React, { useState } from 'react';
import styled from 'styled-components';
import { mq, space } from '../styles/tokens';
import { SectionHeading } from '../components/SectionHeading';
import { ProjectCard } from '../components/ProjectCard';
import { ProjectModal } from '../components/ProjectModal';
import { projects } from '../data/projects';

const Section = styled.section`
  padding: ${space[10]} ${space[4]};
  max-width: 1200px;
  margin: 0 auto;
  ${mq.md} { padding: ${space[12]} ${space[5]}; }
`;

const Grid = styled.div`
  display: grid;
  gap: ${space[3]};
  grid-template-columns: 1fr;

  ${mq.md} {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "featured small1"
      "featured small2"
      "small3   small4"
      "wide     wide";
  }

  ${mq.lg} {
    grid-template-columns: 1.3fr 1fr 1fr;
    grid-template-areas:
      "featured small1 small2"
      "featured small3 small4"
      "wide     wide   wide";
  }
`;

const areas = ['featured', 'small1', 'small2', 'small3', 'small4', 'wide'];

const Projects = () => {
  const [modal, setModal] = useState(null);

  return (
    <Section id="work" aria-labelledby="work-heading">
      <SectionHeading prefix="projects" id="work-heading">Selected work</SectionHeading>
      <Grid>
        {projects.map((p, i) => (
          <ProjectCard
            key={p.slug}
            project={p}
            index={i}
            onOpen={setModal}
            $gridArea={areas[i]}
          />
        ))}
      </Grid>
      {modal && <ProjectModal project={modal} onClose={() => setModal(null)} />}
    </Section>
  );
};

export default Projects;
